<template>
	<ClientOnly>
		<BaseCatalogProductsWidget v-bind="$attrs" v-slot="{items, meta}" :hooks="{afterFetch: checkFrosmoProducts}">
			<slot :items="items" :meta="meta" />
		</BaseCatalogProductsWidget>
	</ClientOnly>
</template>

<script setup>
	const config = useAppConfig();
	const info = useInfo();
	const catalog = useCatalog();
	const {waitForWindowProperty} = useMeta();
	const props = defineProps({
		frosmo: String
	})

	const frosmoStrategies = info.getInfo('frosmo_strategies');
	const frosmoArray = frosmoStrategies.split('\n');
	const frosmoRecCode = shallowRef(null);
	const frosmoStrategy = shallowRef(null);

	// Check if frosmo strategy is defined and fetch frosmo products. If frosmo products are not available use regular list products
	async function checkFrosmoProducts(data) {
		let products = data;
		if(frosmoArray.length && props.frosmo) {
			const foundValue = frosmoArray.find(item => item.startsWith(props.frosmo));
			if (foundValue) {
				const splitValue = foundValue.split('=');
				frosmoRecCode.value = (splitValue.length >= 2) ? splitValue[0] : null;
				frosmoStrategy.value = (splitValue.length >= 2) ? splitValue[1] : null;
			}

			if(frosmoStrategy.value) {
				await waitForWindowProperty('frosmo');
				const frosmoData = await fetchFrosmoProducts(frosmoRecCode.value, frosmoStrategy.value);
				if(frosmoData?.data?.items?.length) products = frosmoData;
			}
		}

		return products;
	}

	// Fetch frosmo products
	async function fetchFrosmoProducts(recommendation_code, strategy) {
		//console.debug('frosmo.easy.strategies, recommendation_code:', recommendation_code, ' strategy:', strategy);

		if (window.frosmo?.easy && window.frosmo?.easy?.strategies && strategy) {
			try {
				const response = await window.frosmo.easy.strategies.fetch(strategy);
				if(response?.data?.length) {
					const productsID = response.data?.map(product => product.id);
					if(!productsID?.length) return null;
					
					return await catalog.fetchProducts({
							mode: 'widget',
							code_exact_sort: 1,
							limit: productsID.length,
							code: productsID,
							response_fields: config.catalog.productsResponseFields
						});
				}
			} catch (error) {
				return null;
			}
		}
		return null;
	}
</script>